import React from "react";
import assign from "lodash/assign";
import BaseOverlay from "./base.jsx";
import { Navigation } from "react-router";
import config from "../../config";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import PassStore from "../../stores/PassStore";
import PassActions from "../../actions/PassActions";

export default statics(
  {
    willTransitionTo({ params }, replace, callback) {
      PassActions.fetchOne(params.passId);
      callback();
    }
  },

  (
    @connectToStores
    class ScanPassOverlay extends React.Component {
      constructor(props) {
        super(props);
        this.cancel = this.cancel.bind(this);
      }

      static getStores() {
        return [PassStore];
      }

      static getPropsFromStores() {
        return {
          getPassById: PassStore.getPassById
        };
      }

      static get contextTypes() {
        return {
          router: React.PropTypes.object.isRequired,
          tenant: React.PropTypes.object
        };
      }

      getStyles(pass) {
        return {
          container: {
            height: "70vw",
            maxHeight: "70vh",
            maxWidth: "70vh",
            margin: "0 auto",
            paddingBottom: "20px"
          },
          pass: {
            background:
              pass &&
              `url(${
                config.endpoint + pass.qr_code_path
              }) no-repeat center center`,
            backgroundSize: "contain",
            height: "100%",
            width: "100%",
            WebkitPrintColorAdjust: "exact"
          }
        };
      }

      cancel() {
        if (this.props.onCancel) {
          this.props.onCancel();
          return;
        }

        this.context.router.push(`/${TENANT.passes_url_pathname}`);
      }

      render() {
        let pass = this.props.getPassById(this.props.params.passId);

        // Don't attempt to render overlay for invalid passes
        if (!pass) {
          return null;
        }

        let styles = this.getStyles(pass);

        return (
          <BaseOverlay onRequestClose={this.cancel}>
            <div style={{ textAlign: "center", fontWeight: "bold" }}>
              Present this QR code at the door for{" "}
              {pass.pass_bucket.is_membership ? this.context.tenant.display_membership : this.context.tenant.display_pass} "{pass.name}".
            </div>
            <div style={styles.container}>
              <div style={styles.pass} />
            </div>
          </BaseOverlay>
        );
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/scan-pass.jsx